module.exports = __webpack_public_path__ + "img/credito_activo.48a2d36f.png";